type InscriptionPageSection =
  | 'RenseignementSiren'
  | 'Etape1Administrateurs'
  | 'Etape2Représentant'
  | 'Etape3InfoComplémentaires'
  | 'Récapitulatif'
  | 'DemandeEnvoyee'
  | 'ApprobationHabilitation'

type ParcoursFcPageSection =
  | 'DemandesAction'
  | 'Campagne'
  | 'CampagneParamètre'

type ParcoursOfaPageSection =
  | 'Etapier'
  | 'EtapierStep1'
  | 'EtapierStep2'
  | 'EtapierStep3'
  | 'EtapierStep4'
  | 'Campagne'

type CommunPageSection =
  | 'Formulaire'
  | 'Etablissements'
  | 'Admins'
  | 'Representants'
  | 'PopupMail'
  | 'PopupEtab'
  | 'Rncp'
  | 'TypeDeclarationModal'

type TextesAppSectionType = InscriptionPageSection | ParcoursFcPageSection | ParcoursOfaPageSection | CommunPageSection;

type TextesAppType = 'Inscription' | 'ParcoursFc' | 'ParcoursOfa' | 'Commun'

const jsonFile = await fetch('/textes.json');
const textes = await jsonFile.json();

export function useTextes(app: TextesAppType, section: TextesAppSectionType) {
  return textes[app][section] || `[Texte à définir (${app},${section})]`;
}